import { render, staticRenderFns } from "./InformesGenerados.vue?vue&type=template&id=310bfe3f&scoped=true&"
import script from "./InformesGenerados.vue?vue&type=script&lang=ts&"
export * from "./InformesGenerados.vue?vue&type=script&lang=ts&"
import style0 from "./InformesGenerados.vue?vue&type=style&index=0&id=310bfe3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bfe3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('310bfe3f', component.options)
    } else {
      api.reload('310bfe3f', component.options)
    }
    module.hot.accept("./InformesGenerados.vue?vue&type=template&id=310bfe3f&scoped=true&", function () {
      api.rerender('310bfe3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformesGenerados/InformesGenerados.vue"
export default component.exports